export default __webpack_public_path__ + "static/media/12.d428c79c.jpg";